// const variantDropdowntemplate = document.createElement('template')

const variantDropdownTemplateHTML = `
<div class="dropdown variant-dropdown">
  <button type="button" class="dropdown-toggle no-styles" aria-expanded="false" aria-controls="variant-dropdown-content">
    <label>
      <slot name="label"></slot>
    </label>
    <div class="selected-variant"></div>
    <select style="pointer-events:none" tabindex="-1"></select>
    <span class="icon">
      <slot name="icon"></slot>
    </span>
  </button>
  <div id="variant-dropdown-content" class="dropdown-content">
    <hh-focus-trap active="false" class="js-focus-trap">
      <slot name="dropdown-list"></slot>
    </hh-focus-trap>
  </div>
</div>`

class VariantSwatchDropdown extends HHBaseElement {
  constructor() {
    super(variantDropdownTemplateHTML, 'closed')

    // Nearest wins: bundle child cards are product-cards inside main-product, and scoping
    // them to main-product lets one row's selection clear every other row's.
    this.mainProduct = this.closest('product-card, mini-product-card, main-product')
    this._toggleDropdown = this._toggleDropdown.bind(this)
    this._handleSelectChange = this._handleSelectChange.bind(this)
    this._handleSelectOption = this._handleSelectOption.bind(this)
    this._handleClickOutside = this._handleClickOutside.bind(this)
    this._dispatchSwatchChangeEvent = this._dispatchSwatchChangeEvent.bind(this)
    this._updateBundleOption = this._updateBundleOption.bind(this)

    this._dropDownList = this.querySelector('[slot="dropdown-list"]')
    this._dropdownParent = this._shadowRoot.querySelector('.dropdown')
    this._toggleLabel = this._shadowRoot.querySelector('label')
    this._dropdownMenu = this._shadowRoot.querySelector('.dropdown-content')
    this._dropDownToggle = this._shadowRoot.querySelector('.dropdown-toggle')
    this._dropDownSelect = this._shadowRoot.querySelector('select')
    this.selectedVariant = this._shadowRoot.querySelector('.selected-variant')
    this.focusElement = this._shadowRoot.querySelector('.js-focus-trap')
    this.colorSwatchRadioInputs = [
      ...this.mainProduct.querySelectorAll(
        '.color-variants .js-swatch-radio'
      ),
    ]
    this.allSizeButtons = [
      ...this.mainProduct.querySelectorAll(
        '.size-variants-container .size-select-container button'
      ),
    ]

    this.otherVariantDropdown = this.closest('product-variants').querySelector(
      '.general-variants-container'
    )

    this.currentFocusIndex = -1
    this._handleKeyDown = this._handleKeyDown.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
    this._attachOptionsListners()
    this._attachKeyboardListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
    this._removeKeyboardListeners()
  }

  open() {
    this.setAttribute('open', true)
    this.setAttribute('aria-expanded', true)
    this.focusElement.setAttribute('active', true)
    this.currentFocusIndex = -1
  }

  close() {
    this.removeAttribute('open', true)
    this.setAttribute('aria-expanded', false)
    this.focusElement.setAttribute('active', false)
  }

  get usesNativeSelect() {
    return this.isiOSOrAndroid || !this.mql.matches
  }

  get isOpen() {
    return this.getAttribute('open')
  }

  get isBundle() {
    return this.getAttribute('data-is-bundle') === 'true'
  }

  // Read live: bundle cards remove options after upgrade, and a cached list would send
  // keyboard focus to detached nodes.
  get _dropdownOptions() {
    return this._dropDownList.querySelectorAll('.dropdown-option')
  }

  get optionTarget() {
    return this.getAttribute('data-option-target')
  }

  set variantName(newValue) {
    // Used to select the right option if dropdown is for a bundle sub-product
    let newVariantId;
    const liquidOptions = this.closest('product-variants').querySelectorAll('.hidden-variants option');
    liquidOptions.forEach((liquidOption) => {
      if (newValue === liquidOption.innerText) {
        newVariantId = liquidOption.value
      }
    })

    if (!newVariantId) return;

    this.variant = newVariantId;
  }

  set variant(newValue) {
    let matchingNewVariants = [...this._dropdownOptions].filter(
      (option) => option.querySelector('input').dataset.variantId === newValue
    )
    // main-product broadcasts the parent's variant to every dropdown on the page,
    // including bundle child cards, which cannot match it and must keep their selection.
    if (!matchingNewVariants.length) return

    this._clearSelectedDropdownInputs()

    this._dropdownOptions.forEach((item) => {
      item.classList.remove('selected');
      const optionLI = item.closest('li');
      if (optionLI) {
        optionLI.removeAttribute('aria-selected');
      }
    });
    if (matchingNewVariants.length > 0) {
      let newVariantClone = matchingNewVariants[0].cloneNode(true)

      newVariantClone.setAttribute('tabindex', -1)
      this.selectedVariant.innerHTML = ''
      this.selectedVariant.append(newVariantClone)
      matchingNewVariants.forEach((label) => {
        label.querySelector('input').checked = true
        label.classList.add('selected')
        const optionLI = label.closest('li');
        if (optionLI) {
          optionLI.setAttribute('aria-selected', 'true');
        }
      })

      if (this.allSizeButtons.length > 0) {
        this.selectedVariant.innerHTML = ''
        this.selectedVariant.innerHTML = matchingNewVariants[0].dataset.label
        this.allSizeButtons
          .filter((button) => button.dataset.variantId === newValue)[0]
          .click()
      } else if (this.otherVariantDropdown) {
        this.selectedVariant.innerHTML = ''
        this.selectedVariant.innerHTML = matchingNewVariants[0].dataset.label

        this.close()
      }
    }
  }

  _dispatchSwatchChangeEvent(newVariantId) {
    if (this.colorSwatchRadioInputs.length) {
      const swatch = this.colorSwatchRadioInputs.find((swatchRadioInput) => swatchRadioInput.dataset.variantId === newVariantId);
      swatch.checked = true;
      swatch.dispatchEvent(new Event('change'));
    }
  }

  _clearSelectedDropdownInputs() {
    let allCheckedInputs = [
      ...this.mainProduct.querySelectorAll('.dropdown-menu input:checked'),
    ]
    allCheckedInputs.forEach((input) => (input.checked = false))
  }

  _setVariantId(id) {
    this.setAttribute('variant', id)
  }

  _toggleDropdown(event) {
    event.preventDefault()
    this.isOpen ? this.close() : this.open()
  }

  _handleSelectChange(event) {
    this.value = event.currentTarget.value
    this.close()
  }

  _onKeyDown(event) {
    if (event.key === 'Escape' && this.isOpen) this.close()
  }

  _attachListeners() {
    this._dropDownToggle.addEventListener('click', this._toggleDropdown)
    this.addEventListener('keydown', this._onKeyDown)
    window.addEventListener('click', this._handleClickOutside)

    if (this.allSizeButtons.length > 0) {
      this._dropdownParent.classList.add('size')
    }
  }

  _removeListeners() {
    this._dropDownToggle.removeEventListener('click', this._toggleDropdown)
    this.removeEventListener('keydown', this._onKeyDown)
    document.removeEventListener('focusin', this._checkFocus)

    // this._nativeSelect.removeEventListener('change', this._handleSelectChange)
    window.removeEventListener('click', this._handleClickOutside)
  }

  _handleSelectOption(event) {
    const value = event.currentTarget.value
    const id = event.currentTarget.dataset.variantId
    this.value = value
    this.variant = id

    if (this.isBundle && this.optionTarget) {
      this._updateBundleOption(value)
    } else {
      this._dispatchSwatchChangeEvent(id)
    }

    this.close();
  }

  _updateBundleOption(newValue) {
    const hiddenOptionInput = document.querySelector(`.single-option-selector[data-option='${this.optionTarget}']`)
    if (!hiddenOptionInput) return;
    hiddenOptionInput.value = newValue
    hiddenOptionInput.dispatchEvent(new Event('change'))

    const currentVariant = this.closest('product-variants')
    if (currentVariant) {
      const parentHandle = currentVariant.getAttribute('product-handle')
      const realVariantID = Array.from(currentVariant.querySelectorAll('select.hidden-variants option')).find(option => option.text == newValue)
      this.triggerGlobalEvent('change::bundle-variant', {
        parent_handle: parentHandle,
        bundle_variant_id: realVariantID?.value
      })
    }
  }

  _handleClickOutside(event) {
    if (!this.contains(event.target)) this.close()
  }

  _applyDropdownState(state) {
    if (state) {
      this._dropdownMenu.classList.add('show')
      this._dropDownToggle.setAttribute('aria-expanded', 'true')
    } else {
      this._dropdownMenu.classList.remove('show')
      this._dropDownToggle.setAttribute('aria-expanded', 'false')
    }
  }

  _attachOptionsListners() {
    for (const dropdownOption of this._dropdownOptions) {
      dropdownOption
        .querySelector('input')
        .addEventListener('change', this._handleSelectOption)

      dropdownOption.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          const input = dropdownOption.querySelector('input')
          this.value = input.value
          this.variant = input.dataset.variantId

          if (this.isBundle && this.optionTarget) {
            this._updateBundleOption(input.value)
          } else {
            this._dispatchSwatchChangeEvent(input.dataset.variantId);
          }

          this.close();
        }
      })
    }
  }

  _attachKeyboardListeners() {
    this.addEventListener('keydown', this._handleKeyDown)
  }

  _removeKeyboardListeners() {
    this.removeEventListener('keydown', this._handleKeyDown)
  }

  _handleKeyDown(event) {
    if (!this.isOpen) return

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        this._focusNextOption()
        break
      case 'ArrowUp':
        event.preventDefault()
        this._focusPreviousOption()
        break
      case 'Enter':
        event.preventDefault()
        this._selectCurrentOption()
        break
      case 'Escape':
        event.preventDefault()
        this.close()
        break
    }
  }

  _focusNextOption() {
    this.currentFocusIndex =
      (this.currentFocusIndex + 1) % this._dropdownOptions.length
    this._updateFocus()
  }

  _focusPreviousOption() {
    this.currentFocusIndex =
      (this.currentFocusIndex - 1 + this._dropdownOptions.length) %
      this._dropdownOptions.length
    this._updateFocus()
  }

  _updateFocus() {
    this._dropdownOptions.forEach((option, index) => {
      if (index === this.currentFocusIndex) {
        option.setAttribute('aria-selected', 'true')
        option.focus()
        this.setAttribute('aria-activedescendant', option.id)
      } else {
        option.removeAttribute('aria-selected')
      }
    })
  }

  _selectCurrentOption() {
    if (this.currentFocusIndex >= 0) {
      const selectedOption = this._dropdownOptions[this.currentFocusIndex]
      const input = selectedOption.querySelector('input')
      if (input) {
        input.checked = true
        this._handleSelectOption({ currentTarget: input })
      }
    }
  }

  static get observedAttributes() {
    return ['name', 'id', 'placeholder', 'open', 'variant']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'variant') {
      this.variant = newValue
    }

    if (name === 'open') {
      this._applyDropdownState(newValue === 'true')
    }
  }
}

window.customElements.define('variant-dropdown', VariantSwatchDropdown)
